import React, { useEffect } from "react";
import CompanySearch from "../../../../../components/common/forms/CompanySearch";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import MainObjectives from "../../../../../components/common/forms/MainObjectives";
import Dropdown from "../../../../../components/common/dropdown/Dropdown";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import ReusableNewCompany from "../../AmendmentAndUpdate/common/ReusableNewCompany";

import BackButton from "../../../../../components/common/backbutton/BackButton";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";

import ReuseCompanySearch from "../ReuseCompanySearch";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const PrivateToPublicConversion = () => {
  const { register, handleSubmit } = useForm();
  const { register: register1, handleSubmit: handleSubmit1 } = useForm();
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [cmpID, setCmpId] = useState(null);

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);
  const [uploadProof, setUploadProof] = useState("");

  const datas = [
    {
      name: "Private Company To Public",
      value: "pvt_to_pub",
      id: uuidv4(),
    },
    {
      name: "Public Company To Private",
      value: "pub_to_pvt",
      id: uuidv4(),
    },
    {
      name: "Single Company To Multipal",
      value: "single_to_multiple",
      id: uuidv4(),
    },
    {
      name: "Multipal Company To Singal",
      value: "multiple_to_single",
      id: uuidv4(),
    },
    {
      name: "Gharelu Banijjya & Ward Firm Single To Multipal Conversions",
      value: "GhareluToMul",
      id: uuidv4(),
    },
    {
      name: "Person Name Transfer Of",
      value: "PersonTransfer",
      id: uuidv4(),
    },
    {
      name: "Gharelu Banijjya & Ward Firm",
      value: "GhareluBan",
      id: uuidv4(),
    },
  ];

  const [selected, setSelected] = useState({
    name: datas[1].name,
    value: datas[1].value,
  });
  const [isActiveLink, setIsActiveLink] = useState(0);
  const [showActiveWork, setShowActiveWork] = useState(0);

  const handleActive = (index) => {
    setShowActiveWork(index);
    setIsActiveLink(index);
  };

  const handleClick = (data) => {
    data.conversion_type = selected.value;
    data.company = cmpID;

    const user = JSON.parse(localStorage.getItem("user"));

    api
      .post("/services/company/conversions/", data)
      .then((response) => {
        toast.success("Data Registered Successfully.");
      })
      .catch((error) => {
        toast.error("Data Registered Failed.");
      });
  };

  const handleSub = (data) => {
    // console.log('data',data)
    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post(`services/company/`, data)
      .then((response) => {
        // console.log("success");
        // console.log(response.data);
        toast.success("Data Registered Successfully");
   
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Data Registration Failed.");
      });
  };

  const handleSearch = () => {
    console.log("search", search);

    if (search !== "") {
      api
        .get(`services/company/search/?q=${search}`)
        .then((response) => {
          console.log(response.data);
          setSearchData(response.data);
          console.log(response.data[0].id);
          setCmpId(response.data[0].id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  let data = [];

  // console.log(selected);
  return (
    <div className="md:px-10 px-3  lg:!px-14">
      {/* <BackButton/> */}
      <div className="px-2">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-2xl font-semibold tracking-wide underline md:!text-2xl">
          {selected.name}
        </p>
        {/* dropdown open*/}
        <div className="flex justify-center my-2">
          <div>
            <div className="dropdown relative">
              <button
                className="dropdown-toggle px-6 py-2.5 bg-primary-red text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-600 hover:shadow-lg focus:bg-red-500 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg active:text-white transition duration-150 ease-in-out flex items-center whitespace-nowrap"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {selected.name}
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="caret-down"
                  className="w-2 ml-2"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                  ></path>
                </svg>
              </button>
              <ul
                className="
               dropdown-menu
               min-w-max
               absolute
               bg-white
               text-lg
               z-50
               float-left
               py-2
               list-none
               text-left
               rounded-lg
               shadow-lg
               mt-1
               hidden
               m-0
               bg-clip-padding
               border-none
             "
                aria-labelledby="dropdownMenuButton1"
              >
                {datas.map((item, i) => {
                  // console.log(item.name);
                  // console.log(i);
                  return (
                    <div key={item.id}>
                      <li>
                        <a
                          className=" dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700 hover:bg-gray-100"
                          href="#"
                          value={selected.value}
                          onClick={(e) =>
                            setSelected({
                              name: item.name,
                              value: item.value,
                            })
                          }
                        >
                          {item.name}
                        </a>
                      </li>
                    </div>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        {/* dropdown close */}

        <div className="flex justify-between">
          <div className=" flex space-x-6 text-primary-red font-Laila text-base font-bold sm:text-lg">
            <div
              onClick={() => handleActive(0)}
              className={`cursor-pointer ${
                isActiveLink === 0 && "border-primary-blue"
              } bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white`}
            >
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" name="radio-btn" id="old" />
            </div>
            <div
              onClick={() => handleActive(1)}
              className={` cursor-pointer ${
                isActiveLink === 1 && "border-primary-blue"
              } bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white`}
            >
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new" />
            </div>
          </div>
          <div className="text-primary-red flex items-center">
            Firm No.
            <p className=" text-primary-blue"> 1234</p>
          </div>
        </div>
        {showActiveWork === 0 ? (
          <form>
            <p className="text-primary-blue  font-Calistoga  my-3 text-lg pt-4">
              1. Company Name & Other Details
            </p>
            <div>
              {/* <CompanySearch register={register} /> */}

              {/* company search */}
              <div className="">
                <div className="flex item-center border-2 p-3 w-fit border-primary-blue">
                  <p className=" text-primary-red font-Laila  md:text-lg font-bold">
                    कम्पनी वा ब्यवसायको नाम:
                  </p>

                  <ReuseCompanySearch setCmpId={setCmpId} />

                  {/* <input
                    className=" border-2 text-primary-blue pl-5 font-bold  border-primary-red outline-none rounded-xl"
                    type="search"
                    placeholder="Search"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    // {...register("company_name", { required: false })}
                  />
                  <div
                    className="bg-red-400 rounded p-1 m-auto cursor-pointer"
                    onClick={handleSearch}
                  >
                    search
                  </div> */}
                </div>
              </div>
            </div>
            <div className=" border-primary-blue my-3 ">
              <p className="text-primary-blue font-Calistoga my-5 text-lg underline">
                2. Main Objectives
                <span className="text-primary-blue font-Laila underline">
                  (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
                </span>
              </p>
            </div>
            <MainObjectives register={register} />
            <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue  font-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
            <FormBranch register={register} name="working_branch" />
            <FormButtom />
            
            <NewFormPayment
            handleSubmit={handleSubmit}
            handleClick={handleClick}
            setUploadProof={setUploadProof}
          />
          </form>
        ) : (
          <form>
            
            <div className="mt-3">
              {(user?.user_type === "ST" || user?.user_type === "AD") && (
                <AdminSearchCustomer setUserId={setUserId} />
              )}
            </div>
            {/* not linked company details start*/}
            {/* <div className="mt-4">
              <div className="flex-col flex md:flex-row flex-wrap">
                <div className="flex flex-1  border items-center m-0 px-2 border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    कम्पनी नाम :
                  </label>
                  <input
                    type="text"
                    placeholder=" "
                    name="company_name"
                    
                    className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    कम्पनीको ठेगाना :
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="address"
                    className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                  />
                </div>
              </div>
              <div className="flex-col flex md:flex-row flex-wrap">
                <div className="flex flex-1  border items-center m-0 px-2 border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    सम्बन्धित ब्यक्तीको नाम :
                  </label>
                  <input
                    type="text"
                    placeholder=" "
                    name="company_name"
                    className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    कम्पनीको ठेगाना :
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="address"
                    className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                  />
                </div>
              </div>
              <div className="flex-col flex md:flex-row flex-wrap">
                <div className="flex flex-1  border items-center m-0 px-2 border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    सम्बन्धित व्यक्तीको सम्पर्क नं.:
                  </label>
                  <input
                    type="text"
                    placeholder=" "
                    name="company_name"
                    className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    सम्‍बन्धीत व्यक्तीको ठेगाना :
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="address"
                    className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                  />
                </div>
              </div>
              <div className="flex-col flex md:flex-row flex-wrap">
                <div className="flex flex-1  border items-center m-0 px-2 border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    कम्पनीको Username:
                  </label>
                  <input
                    type="text"
                    placeholder=" "
                    name="company_name"
                    className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                  />
                </div>
                <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                  <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                    कम्पनीको Password:
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    name="address"
                    className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                  />
                </div>
              </div>
              <div className="border-2 bg-pink-100 border-primary-blue mt-3">
                <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
                  शेयर सदस्यहरुको संख्याको आधारमा ३ महिने विवरण पेश गर्दा तपाईको
                  जम्मा लाग्ने रकम रु.५,०००।– मात्र
                </p>
              </div>

              <div className=" border-primary-blue mt-3">
                <p className="flex text-primary-blue mt-0 font-semibold leading-10 text-center">
                  <p className=" text-primary-red mr-2">नोट :</p> माथी उल्लेखित
                  रकम ७ जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ, यदि ७ जना
                  भन्दा बढि भएमा प्रती सदस्य रु.५००।–को दरले थप शुल्क बृद्धि
                  हुदै जानेछ ।
                </p>
              </div>
            </div> */}
 <p className="text-primary-blue  font-Calistoga  my-3 text-lg pt-4">
              1. Company Name & Other Details
            </p>
            <ReusableNewCompany register={register1} />
            {/* not linked company details */}
            <div className=" border-primary-blue my-3 ">
              <p className="text-primary-blue font-Calistoga my-5 text-lg underline">
                2. Main Objectives
                <span className="text-primary-blue font-Laila underline">
                  (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
                </span>
              </p>
            </div>

            <MainObjectives register={register1} />
            <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue  font-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
            <FormBranch register={register1} />
            <FormButtom />

            <NewFormPayment
            handleSubmit={handleSubmit}
            handleClick={handleClick}
            setUploadProof={setUploadProof}
          />
          </form>
        )}
      </div>
    </div>
  );
};

export default PrivateToPublicConversion;
